import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { propTypes } from '../../util/types';
import { ensureCurrentUser } from '../../util/data';
import { fetchCurrentUser, sendVerificationEmail } from '../../ducks/user.duck';
import {
    LayoutSideNavigation,
    LayoutWrapperMain,
    LayoutWrapperSideNav,
    LayoutWrapperTopbar,
    LayoutWrapperFooter,
    Page,
    Hero,
} from '../../components';
import { ContactDetailsForm } from '../../forms';

import { isScrollingDisabled } from '../../ducks/UI.duck';
import { saveContactDetails, saveContactDetailsClear } from './ContactDetailsPage.duck';
import heroimage from '../../assets/detalleselva.jpg';
import css from './ContactDetailsPage.css';
import Header from '../../newPages/NewLandingPage/Sections/Header/Header';
import Footer from '../../newPages/NewLandingPage/Sections/Footer/Footer';
import { withRouter } from 'react-router-dom';

export const ContactDetailsPageComponent = props => {
    const {
        saveEmailError,
        savePhoneNumberError,
        saveContactDetailsInProgress,
        currentUser,
        contactDetailsChanged,
        onChange,
        scrollingDisabled,
        sendVerificationEmailInProgress,
        sendVerificationEmailError,
        onResendVerificationEmail,
        onSubmitContactDetails,
        intl,
    } = props;

    const tabs = [
        {
            text: <FormattedMessage id="ContactDetailsPage.paisaje" />,
            selected: false,
            linkProps: {
                name: 'YourListingsPage',
            },
        },
        {
            text: <FormattedMessage id="ContactDetailsPage.profileSettings" />,
            selected: false,
            linkProps: {
                name: 'ProfileSettingsPage',
            },
        },
        {
            text: <FormattedMessage id="ContactDetailsPage.contactDetailsTabTitle" />,
            selected: true,
            linkProps: {
                name: 'ContactDetailsPage',
            },
        },
        {
            text: <FormattedMessage id="ContactDetailsPage.passwordTabTitle" />,
            selected: false,
            linkProps: {
                name: 'PasswordChangePage',
            },
        },
        {
            text: <FormattedMessage id="ContactDetailsPage.updateCard" />,
            selected: false,
            linkProps: {
                name: 'UpdateCardPage',
            },
        },
        {
            text: <FormattedMessage id="PaymentHistoryPage.title" />,
            selected: false,
            linkProps: {
                name: 'PaymentHistoryPage',
            },
        },
    ];

    const user = ensureCurrentUser(currentUser);
    const currentEmail = user.attributes.email || '';
    const currentFirstName = user.attributes.profile.firstName || '';
    const currentPhoneNumber = user.attributes.profile.phoneNumber || '';
    const contactInfoForm = user.id ? (
        <ContactDetailsForm
            className={css.form}
            initialValues={{ email: currentEmail, phoneNumber: currentPhoneNumber }}
            saveEmailError={saveEmailError}
            savePhoneNumberError={savePhoneNumberError}
            currentUser={currentUser}
            onResendVerificationEmail={onResendVerificationEmail}
            onSubmit={values =>
                onSubmitContactDetails({ ...values, currentEmail, currentPhoneNumber })
            }
            onChange={onChange}
            inProgress={saveContactDetailsInProgress}
            ready={contactDetailsChanged}
            sendVerificationEmailInProgress={sendVerificationEmailInProgress}
            sendVerificationEmailError={sendVerificationEmailError}
        />
    ) : null;

    const title = intl.formatMessage({ id: 'ContactDetailsPage.title' });
    return (
        <Page title={title} scrollingDisabled={scrollingDisabled}>
            <LayoutSideNavigation>
                <LayoutWrapperTopbar>
                    <Header
                        transparent
                        currentPath={props.location.pathname}
                        user={props.user}
                        history={props.history}
                    />

                    {/*<UserNav selectedPageName="ContactDetailsPage" />*/}
                    <Hero
                        size="medium"
                        title={intl.formatMessage(
                            { id: 'TopbarMobileMenu.greeting' },
                            { displayName: currentFirstName }
                        )}
                        image={heroimage}
                    />
                </LayoutWrapperTopbar>
                <LayoutWrapperSideNav tabs={tabs} />
                <LayoutWrapperMain>
                    <div className={css.content}>
                        <h1 className={css.title}>
                            <FormattedMessage id="ContactDetailsPage.heading" />
                        </h1>
                        {contactInfoForm}
                    </div>
                </LayoutWrapperMain>
                <LayoutWrapperFooter>
                    <Footer history={props.history} />
                </LayoutWrapperFooter>
            </LayoutSideNavigation>
        </Page>
    );
};

ContactDetailsPageComponent.defaultProps = {
    saveEmailError: null,
    savePhoneNumberError: null,
    currentUser: null,
    sendVerificationEmailError: null,
};

const { bool, func } = PropTypes;

ContactDetailsPageComponent.propTypes = {
    saveEmailError: propTypes.error,
    savePhoneNumberError: propTypes.error,
    saveContactDetailsInProgress: bool.isRequired,
    currentUser: propTypes.currentUser,
    contactDetailsChanged: bool.isRequired,
    onChange: func.isRequired,
    onSubmitContactDetails: func.isRequired,
    scrollingDisabled: bool.isRequired,
    sendVerificationEmailInProgress: bool.isRequired,
    sendVerificationEmailError: propTypes.error,
    onResendVerificationEmail: func.isRequired,

    // from injectIntl
    intl: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
    // Topbar needs user info.
    const { currentUser, sendVerificationEmailInProgress, sendVerificationEmailError } = state.user;
    const {
        saveEmailError,
        savePhoneNumberError,
        saveContactDetailsInProgress,
        contactDetailsChanged,
    } = state.ContactDetailsPage;
    const user = state.user.currentUser
        ? {
              initials: state.user.currentUser.attributes.profile.abbreviatedName,
              name:
                  state.user.currentUser.attributes.profile.firstName +
                  ' ' +
                  state.user.currentUser.attributes.profile.lastName,
          }
        : null;
    return {
        user,
        saveEmailError,
        savePhoneNumberError,
        saveContactDetailsInProgress,
        currentUser,
        contactDetailsChanged,
        scrollingDisabled: isScrollingDisabled(state),
        sendVerificationEmailInProgress,
        sendVerificationEmailError,
    };
};

const mapDispatchToProps = dispatch => ({
    onChange: () => dispatch(saveContactDetailsClear()),
    onResendVerificationEmail: () => dispatch(sendVerificationEmail()),
    onSubmitContactDetails: values => dispatch(saveContactDetails(values)),
});

const ContactDetailsPage = compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    injectIntl
)(ContactDetailsPageComponent);

ContactDetailsPage.loadData = () => {
    // Since verify email happens in separate tab, current user's data might be updated
    return fetchCurrentUser();
};

export default ContactDetailsPage;
